/* ROKZOG product page (2026-10-17, no Dawn). Works on sections/main-product:
   1 variants: the colour + size boxes pick the variant here (no reload), price, stock label, button, URL
   2 add to cart without leaving the page (rz.added shows the pop-up), errors under the button
   3 photos: one big photo, thumbnails, arrows, swipe, arrow keys; a colour pick jumps to that colour's photos
     (alt text ends "· <Colour>", else the variant's own photo); a click or tap zooms in on that spot, drag moves it
   4 title: identity label on the piece line; XL → L when the buy block would leave the first screen
   5 description → specs in the info column + the design story and numbered details under the card
   6 same phrase / the product's line / buy the whole line
   7 sticky add to cart
   8 "You might also wear": identity labels on its piece lines */
function rzProduct() {   // runs again when the Print choice swaps another print in (end of this file)
  var root = document.querySelector('[data-rz-product]');
  if (!root || root.dataset.init) return;
  root.dataset.init = 1;
  // listeners on window / document end when the next product is swapped in
  if (window.rzProductLife) window.rzProductLife.abort();
  var life = window.rzProductLife = window.AbortController ? new AbortController() : null;
  var sig = { signal: life ? life.signal : undefined };
  var rz = window.rz || {};
  function $(s, el) { return (el || root).querySelector(s); }
  function $$(s, el) { return [].slice.call((el || root).querySelectorAll(s)); }
  function json(sel) { var el = document.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : t; return d.innerHTML; }
  function txt(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }

  var variants = json('[data-rz-variants]') || [];
  var form = $('form.rz-pd__form'), info = $('[data-rz-info]');
  var addBtn = $('[data-rz-add]'), addLabel = $('[data-rz-add-label]'), priceEl = $('[data-rz-price]'), wasEl = $('[data-rz-compare]');
  var stockEl = $('[data-rz-stock]'), errEl = $('[data-rz-err]');
  var fieldsets = $$('.rz-opt[data-pos]');   // the variant options (the Print choice links to other products)

  /* ---------- 1 variants ---------- */
  // the select is for visitors without JavaScript; here a hidden id follows the boxes
  var idIn = form && form.querySelector('input[type=hidden][name=id]');
  var nojs = $('[data-rz-nojs]'), nojsSel = nojs && nojs.querySelector('select');
  if (nojsSel) {
    idIn = document.createElement('input'); idIn.type = 'hidden'; idIn.name = 'id'; idIn.value = nojsSel.value;
    nojs.replaceWith(idIn);
  } else if (nojs) nojs.classList.add('is-js');
  function picked() { return fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; }); }
  function match(sel) { return variants.filter(function (v) { return v.o.every(function (x, i) { return x === sel[i]; }); })[0] || null; }
  var current = fieldsets.length ? match(picked()) : variants[0] || null;
  function markValues(sel) {   // a value is "off" when no available variant has it with the other choices as they are
    fieldsets.forEach(function (f, i) {
      f.querySelectorAll('input').forEach(function (inp) {
        var test = sel.slice(); test[i] = inp.value;
        inp.classList.toggle('is-off', !variants.some(function (v) { return v.a && v.o.every(function (x, j) { return x === test[j]; }); }));
      });
    });
  }
  function setButton(v) {
    var ok = !!(v && v.a);
    addBtn.disabled = !ok;
    addBtn.classList.toggle('is-soldout', !ok);
    addLabel.textContent = ok ? 'Add to cart' : (v ? 'Sold out' : 'Unavailable');
    var none = !variants.some(function (x) { return x.a; });
    stockEl.textContent = none ? 'Sold out' : 'Out of stock';
    stockEl.hidden = ok;
  }
  function update(byUser) {
    var sel = picked(), v = match(sel);
    current = v;
    if (idIn) idIn.value = v ? v.id : '';
    if (v) { priceEl.textContent = v.p; wasEl.innerHTML = v.c ? '<s>' + esc(v.c) + '</s>' : ''; }
    setButton(v); markValues(sel);
    if (errEl) errEl.hidden = true;
    if (byUser && v && history.replaceState) {
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString());
    }
    root.dispatchEvent(new CustomEvent('rz:variant', { detail: { variant: v } }));
  }
  fieldsets.forEach(function (f) {
    f.addEventListener('change', function (e) {
      var before = current && current.m;
      update(true);
      if (f.classList.contains('rz-opt--colour')) gallery.colour(e.target.value, current);
      // other options: only when that variant really has a photo of its own (a size change stays on the photo being looked at)
      else if (current && current.m && current.m !== before && !gallery.hasColourPhotos()) gallery.media(current.m);
    });
  });
  if (fieldsets.length) markValues(picked());
  // Print choice (front / back / both are separate products): the other prints open on the colour + size picked here
  var printLinks = $$('[data-rz-prints] a[data-v]');
  function printHrefs() {
    printLinks.forEach(function (a) {
      var m = {}; try { m = JSON.parse(a.dataset.v); } catch (e) {}
      var id = current && m[current.t];
      a.href = a.dataset.url + (id ? '?variant=' + id : '');
    });
  }
  if (printLinks.length) { printHrefs(); root.addEventListener('rz:variant', printHrefs); }

  /* ---------- 2 add to cart, stay on the page ---------- */
  if (form && window.fetch && window.FormData) {
    form.addEventListener('submit', function (e) {
      if (!idIn || !idIn.value) return;
      e.preventDefault();
      if (addBtn.disabled) return;
      var label = addLabel.textContent;
      addBtn.disabled = true; addBtn.classList.add('is-busy'); addLabel.textContent = 'Adding…';
      fetch((rz.routes ? rz.routes.cartAdd : '/cart/add') + '.js', { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function (item) { if (rz.added) rz.added(item); })
        .catch(function (err) {
          if (errEl) { errEl.textContent = (err && (err.description || err.message)) || 'That did not work. Try again.'; errEl.hidden = false; }
        })
        .then(function () { addBtn.classList.remove('is-busy'); addLabel.textContent = label; setButton(current); });
    });
  }

  /* ---------- 3 photos ---------- */
  var gallery = (function () {
    var gal = $('[data-rz-gal]'), list = gal && $('[data-rz-gal-list]', gal);
    var api = { colour: function () {}, media: function () {}, hasColourPhotos: function () { return false; } };
    if (!list) return api;
    var slides = $$(':scope > .rz-gal__slide', list);
    var thumbsUl = $('[data-rz-thumbs]', gal), thumbs = thumbsUl ? $$('.rz-gal__th', thumbsUl) : [];
    var arrows = $$('[data-rz-step]', gal);
    // one colour's photos at a time (sections/main-product marks every photo with data-colour; empty = every colour)
    var byColour = gal.classList.contains('is-by-colour');
    function vis() { return slides.filter(function (s) { return !s.hidden; }); }
    function thumbOf(slide) { return thumbs.filter(function (t) { return t.dataset.i === slide.dataset.i; })[0]; }
    var cur = slides.filter(function (s) { return s.classList.contains('is-on') && !s.hidden; })[0] || vis()[0];
    function set(slide) {
      if (slide !== cur) zoomOut();
      cur = slide;
      slides.forEach(function (s) {
        s.classList.toggle('is-on', s === slide);
        if (s !== slide) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      var t = slide && thumbOf(slide);
      thumbs.forEach(function (x) { if (x === t) x.setAttribute('aria-current', 'true'); else x.removeAttribute('aria-current'); });
      // keep the active thumbnail in view when the row scrolls (phones, many photos)
      if (t && thumbsUl.scrollWidth > thumbsUl.clientWidth + 1) thumbsUl.scrollTo({ left: t.parentElement.offsetLeft - (thumbsUl.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' });
    }
    function go(i, instant) {   // i = position among the photos shown
      var v = vis(), n = v.length; if (!n) return;
      i = (i + n) % n; set(v[i]);
      list.scrollTo({ left: v[i].offsetLeft, behavior: instant ? 'auto' : 'smooth' });
    }
    function pos() { return Math.max(0, vis().indexOf(cur)); }
    // zoom: a click or tap zooms the photo in at that spot, dragging moves it around, another click or tap zooms out
    var Z = 2.5, zoomed = null, drag = null, moved = false;
    function place(b, x, y) {   // the zoomed photo always covers its box
      b._x = Math.min(0, Math.max(b.clientWidth * (1 - Z), x));
      b._y = Math.min(0, Math.max(b.clientHeight * (1 - Z), y));
      $('.rz-gal__img', b).style.transform = 'translate(' + b._x + 'px, ' + b._y + 'px) scale(' + Z + ')';
    }
    function zoomIn(b, e) {
      var r = b.getBoundingClientRect(), img = $('.rz-gal__img', b);
      var x = e.detail ? e.clientX - r.left : r.width / 2, y = e.detail ? e.clientY - r.top : r.height / 2;   // keyboard: the middle
      img.sizes = Math.ceil(r.width * Z) + 'px';   // the file that is sharp at the zoomed size, up to the photo's own width
      zoomed = b; b.classList.add('is-zoom'); b.setAttribute('aria-pressed', 'true'); gal.classList.add('is-zoomed');
      place(b, x * (1 - Z), y * (1 - Z));   // the spot under the finger stays put
      sharpen(b, img, r.width);
    }
    // Store photos are at most 2000 px (Printful's largest mockup; 1000 px for the Chaser hoodie), so zoomed in they
    // are enlarged past their own pixels. Once the zoom has settled an unsharp mask (#rz-sharp, rz-product.css) firms
    // up the lettering, stronger the more the photo is enlarged; none when it isn't.
    var sharpT;
    function sharpen(b, img, w) {
      var px = Math.max.apply(null, (img.getAttribute('srcset') || '').match(/\d+(?=w)/g) || [0]);
      var a = px ? Math.min(.8, (w * Z * (window.devicePixelRatio || 1) / px - 1) * .6) : 0;
      clearTimeout(sharpT);
      if (a < .1) return;
      var f = document.getElementById('rz-sharp');
      if (!f) {
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('aria-hidden', 'true'); svg.setAttribute('width', '0'); svg.setAttribute('height', '0'); svg.style.position = 'absolute';
        svg.innerHTML = '<filter id="rz-sharp" color-interpolation-filters="sRGB"><feGaussianBlur in="SourceGraphic" stdDeviation="1" result="b"/>' +
          '<feComposite in="SourceGraphic" in2="b" operator="arithmetic" k1="0" k2="1" k3="0" k4="0"/></filter>';
        document.body.appendChild(svg); f = svg.firstChild;
      }
      var c = f.lastChild; c.setAttribute('k2', 1 + a); c.setAttribute('k3', -a);
      sharpT = setTimeout(function () { if (zoomed === b) b.classList.add('is-sharp'); }, 400);   // after the zoom's .35s move
    }
    function zoomOut() {
      if (!zoomed) return;
      clearTimeout(sharpT); zoomed.classList.remove('is-sharp');
      $('.rz-gal__img', zoomed).style.transform = '';
      zoomed.classList.remove('is-zoom', 'is-drag'); zoomed.setAttribute('aria-pressed', 'false'); gal.classList.remove('is-zoomed');
      zoomed = null; drag = null;
    }
    list.addEventListener('pointerdown', function (e) {
      moved = false;
      if (!zoomed || !zoomed.contains(e.target)) return;
      drag = { x: e.clientX, y: e.clientY, ox: zoomed._x, oy: zoomed._y, id: e.pointerId };
      try { zoomed.setPointerCapture(e.pointerId); } catch (err) {}   // keeps the drag going when the finger leaves the photo
    });
    list.addEventListener('pointermove', function (e) {
      if (!drag || e.pointerId !== drag.id) return;
      var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
      if (!moved && Math.abs(dx) + Math.abs(dy) < 6) return;   // a tap, not a drag
      moved = true; zoomed.classList.add('is-drag');
      place(zoomed, drag.ox + dx, drag.oy + dy);
    });
    function endDrag() { drag = null; if (zoomed) zoomed.classList.remove('is-drag'); }
    list.addEventListener('pointerup', endDrag);
    list.addEventListener('pointercancel', endDrag);
    list.addEventListener('dragstart', function (e) { e.preventDefault(); });
    // swipe / trackpad: where the row comes to rest is the photo shown
    var settle;
    list.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(function () { var v = vis(), i = Math.round(list.scrollLeft / Math.max(1, list.clientWidth)); if (v[i] && v[i] !== cur) set(v[i]); }, 90);
    }, { passive: true });
    gal.addEventListener('click', function (e) {
      var s = e.target.closest('[data-rz-step]'); if (s) return go(pos() + Number(s.dataset.rzStep));
      var t = e.target.closest('.rz-gal__th');
      if (t) { var sl = slides.filter(function (x) { return x.dataset.i === t.dataset.i; })[0]; return go(vis().indexOf(sl)); }
      var z = e.target.closest('[data-rz-zoom]'); if (!z) return;
      if (z === zoomed) { if (!moved || !e.detail) zoomOut(); }   // the end of a drag isn't a tap
      else { zoomOut(); zoomIn(z, e); }
    });
    gal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && zoomed) { e.preventDefault(); return zoomOut(); }
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      if (e.target.closest('video, input')) return;
      e.preventDefault(); go(pos() + (e.key === 'ArrowRight' ? 1 : -1));
      var t = cur && thumbOf(cur); if (t && document.activeElement && document.activeElement.classList.contains('rz-gal__th')) t.focus({ preventScroll: true });
    });
    function refresh() {   // arrows and thumbnails only when the colour has more than one photo
      var n = vis().length;
      arrows.forEach(function (a) { a.hidden = n < 2; });
      if (thumbsUl) { thumbsUl.hidden = n < 2; gal.style.setProperty('--rz-n', Math.max(1, n)); }
    }
    function showColour(colour) {
      var c = String(colour || '');
      var keep = function (el) { var d = el.dataset.colour || ''; return !d || d === c; };
      if (!slides.some(keep)) keep = function () { return true; };   // a colour without photos of its own: show them all
      slides.forEach(function (s) { s.hidden = !keep(s); });
      thumbs.forEach(function (t) { t.parentElement.hidden = !keep(t.parentElement); });
      refresh();
      list.scrollTo({ left: 0 });
      if (thumbsUl) thumbsUl.scrollTo({ left: 0 });
      go(0, true);
    }
    function firstOf(colour) {
      if (!colour) return -1;
      var end = '· ' + String(colour).toLowerCase(), v = vis();
      for (var i = 0; i < v.length; i++) { var a = (v[i].dataset.alt || '').trim().toLowerCase(); if (a.slice(-end.length) === end) return i; }
      return -1;
    }
    function byMedia(id) { var v = vis(); for (var i = 0; i < v.length; i++) if (String(v[i].dataset.mediaId) === String(id)) return i; return -1; }
    api.colour = function (colour, v) {
      if (byColour) return showColour(colour);   // swap in that colour's photos, starting at its first one
      var i = firstOf(colour); if (i < 0 && v && v.m) i = byMedia(v.m); if (i > -1) go(i);
    };
    api.media = function (id) { var i = byMedia(id); if (i > -1) go(i); };
    api.hasColourPhotos = function () { return byColour || slides.some(function (s) { return / · [^·]+$/.test(s.dataset.alt || ''); }); };
    api.firstImage = function () { var s = vis()[0]; return s && s.querySelector('.rz-gal__img'); };
    // the photo for a variant: its own photo when it shows with the colour picked, else that colour's first one
    api.imageFor = function (v) {
      var own = v && v.m && slides.filter(function (s) { return String(s.dataset.mediaId) === String(v.m) && !s.hidden; })[0];
      var s = own || vis()[0]; return s && s.querySelector('.rz-gal__img');
    };
    refresh();
    // opened on a colour further down the list (?variant=…) or on another photo: start there
    function start() { var p = pos(); if (p > 0) go(p, true); else if (cur) set(cur); }
    start(); addEventListener('load', start, { once: true, signal: sig.signal });
    addEventListener('resize', function () { zoomOut(); list.scrollTo({ left: cur ? cur.offsetLeft : 0 }); }, sig);
    return api;
  })();

  /* ---------- 4 title ---------- */
  var h1 = $('.rz-pd__h'), kindEl = $('[data-rz-kind]');
  function label() { if (kindEl && window.rzWith) kindEl.textContent = rzWith(kindEl.dataset.k || (kindEl.dataset.k = kindEl.textContent.trim()), location.pathname); }
  label(); document.addEventListener('rz:ident', label, sig);
  var card = $('.rz-pd__card');
  function hero() { if (!card) return; var top = card.getBoundingClientRect().top + scrollY; document.documentElement.style.setProperty('--rz-head', Math.round(Math.max(0, top)) + 'px'); }
  function fit() {
    var buy = $('[data-rz-buy]');
    if (!info || !h1 || !buy || innerWidth < 990) { if (info) info.classList.remove('rz-nosticky'); return; }
    if (!h1.dataset.long) h1.dataset.long = h1.classList.contains('rz-t--long') ? '1' : '0';
    if (h1.dataset.long === '0') h1.classList.remove('rz-t--long');
    if (buy.getBoundingClientRect().bottom + scrollY > innerHeight - 16) h1.classList.add('rz-t--long');
    // design view: the lettering gives up just enough height to keep Add to cart on the first screen
    var lt = h1.querySelector('.rz-lettering');
    if (lt && h1.dataset.view === 'design') {
      lt.style.maxHeight = '';
      var over = buy.getBoundingClientRect().bottom + scrollY - (innerHeight - 16);
      if (over > 0) lt.style.maxHeight = Math.max(100, Math.round(lt.getBoundingClientRect().height - over)) + 'px';
    } else if (lt) lt.style.maxHeight = '';
    info.classList.toggle('rz-nosticky', info.offsetHeight > innerHeight - 48);
  }
  /* thumbnail row height, so photo + row fill the first screen (rz-product.css) */
  function rowH() { var t = $('[data-rz-thumbs]'); var g = $('[data-rz-gal]'); if (t && g) g.style.setProperty('--rz-thumbs', t.offsetHeight + 'px'); }
  function layout() { hero(); rowH(); fit(); }

  /* ---------- 5 description → specs + the design story and numbered details ---------- */
  (function () {
    var box = $('[data-rz-desc]');
    if (!box) return;
    var self = json('[data-self]') || {};
    var LEDE = self.lede || 'Hand-lettered by ROKZOG in Berlin. Printed for you when you order: no warehouse, no leftovers.';
    var html = box.innerHTML;
    var sizeAt = html.search(/<p>\s*<strong[^>]*size-guide-title/i);
    var sizeHTML = sizeAt > -1 ? html.slice(sizeAt) : '';
    var textHTML = sizeAt > -1 ? html.slice(0, sizeAt) : html;
    var tmp = document.createElement('div');
    tmp.innerHTML = textHTML.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n\n');
    var blocks = tmp.textContent.split(/\n\s*\n/).map(function (b) { return b.trim(); }).filter(Boolean);
    if (!blocks.length) { box.hidden = !box.textContent.trim(); return; }
    var intro = [], bullets = [], made = [], trace = [], safety = [], afterSafety = false, inTrace = false;
    blocks.forEach(function (b, i) {
      var lines = b.split('\n').map(function (l) { return l.trim(); })
        .filter(function (l) { return l && !/^[.\s,;:·•-]*$/.test(l) && !/^\d{4,5}$/.test(l); });
      if (!lines.length) return;
      b = lines.join('\n');
      if (afterSafety) { safety = safety.concat(lines); return; }
      if (/GPSR|product safety/i.test(b)) afterSafety = true;
      // "<br>\n" makes every line a block of its own: the "- Knitting / Dyeing" lines after "Traceability:" belong to it,
      // and "20% recycled polyester" in a fabric line (the Chaser hoodie) doesn't, only "Contains 0% recycled polyester"
      var isTrace = /^[•·]?\s*traceability/i.test(b) || /contains \d+% recycled|dangerous substances|microfibers/i.test(b) || (inTrace && /^[-–]/.test(b));
      inTrace = isTrace;
      if (/made especially for you|on demand/i.test(b)) made.push(b);
      else if (isTrace) trace = trace.concat(lines);
      else if (/age restrictions|warranty|compliance|GPSR|safety/i.test(b)) safety = safety.concat(lines);
      else if (lines.every(function (l) { return /^[•·\-–]/.test(l); })) bullets = bullets.concat(lines);
      else if (i === 0) intro.push(b);
      else bullets = bullets.concat(lines);
    });
    if (!bullets.length && !made.length && !sizeHTML) return;   // not the usual structure: the description stays as it is
    function list(lines) { return '<ul>' + lines.map(function (l) { return '<li>' + esc(l.replace(/^[•·\-–]\s*/, '')) + '</li>'; }).join('') + '</ul>'; }
    var phrase = h1 ? txt(h1.querySelector('.rz-name')) : '';
    var size = '';
    if (sizeHTML) {
      var s = document.createElement('div'); s.innerHTML = sizeHTML;
      var t = s.querySelector('table');
      if (t) {
        t.removeAttribute('style'); t.querySelectorAll('[style]').forEach(function (x) { x.removeAttribute('style'); });
        t.querySelectorAll('td, th').forEach(function (c) {
          var v = c.textContent.trim();
          if (/^\d+(\.\d+)?$/.test(v)) c.dataset.in = v;
          if (/inches/i.test(v)) c.dataset.unitLabel = v;
        });
        size = '<div class="rz-unit" role="group" aria-label="Units"><button type="button" data-u="cm" aria-pressed="true">cm</button><button type="button" data-u="in" aria-pressed="false">inch</button></div><div class="rz-dl__table">' + t.outerHTML + '</div>';
      }
    }
    // specs in the info column, read from the description
    function find(re) { var hit = bullets.concat(trace).filter(function (l) { return re.test(l); })[0]; return hit ? hit.replace(/^[•·\-–]\s*/, '').replace(/^[^:]*:\s*/, '') : ''; }
    var spec = [
      // "60% Airlume combed and ring-spun cotton" -> "60% cotton" (the old rule left "60% and cotton"); "organic" stays
      ['Fabric', find(/\d+%/).replace(/\b(?:(?:pre-?shrunk|ring-?spun|combed|airlume|soft|premium)\s+(?:and\s+(?=(?:pre-?shrunk|ring-?spun|combed|airlume|soft|premium)\b))?)+/gi, '')],
      ['Weight', (function (w) { var g = w.match(/([\d.,]+)\s*g\/m²/i); if (g) return Math.round(parseFloat(g[1].replace(',', '.'))) + ' g/m²'; var o = w.match(/[\d.,]+\s*oz\/yd²/i); return o ? o[0] : ''; })(find(/weight/i))],
      ['Lettering', 'By hand, Berlin'],
      ['Printed', 'On demand, EU'],
      ['Ships', '3-6 days']
    ].filter(function (r) { return r[1]; });
    box.classList.remove('rz-rte'); box.classList.add('is-specs');
    box.innerHTML = '<p class="rz-label rz-spec__h">Specs</p><dl class="rz-spec">' +
      spec.map(function (r) { return '<div class="rz-spec__row"><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>';
    function row(n, title, body, open) {
      return body ? '<details class="rz-dl__row"' + (open ? ' open' : '') + '><summary><span class="rz-dl__n">' + n + '</span><span class="rz-dl__t">' + title + '</span><span class="rz-dl__x" aria-hidden="true">+</span></summary><div class="rz-dl__body">' + body + '</div></details>' : '';
    }
    var rows = [
      ['The piece', bullets.length ? list(bullets) : (intro.length ? '<p>' + esc(intro.join(' ')) + '</p>' : ''), true],
      ['Size guide', size],
      ['Made on demand', made.map(function (m) { return '<p>' + esc(m) + '</p>'; }).join('')],
      ['Traceability &amp; safety', (trace.length ? list(trace) : '') + (safety.length ? '<p class="rz-dl__small">' + safety.map(esc).join('<br>') + '</p>' : '')]
    ].filter(function (r) { return r[1]; });
    var wrap = document.createElement('section');
    wrap.className = 'rz-card-wrap rz-dl-wrap'; wrap.setAttribute('aria-label', 'Details');
    wrap.innerHTML = '<div class="rz-card rz-dl">' +
      '<div class="rz-dl__story"><span class="rz-label">Design</span><p class="rz-dl__ph">' + esc(phrase) + '</p>' +
        '<p class="rz-dl__lede">' + esc(LEDE) + '</p>' + (bullets.length && intro.length ? '<p class="rz-dl__intro">' + esc(intro.join(' ')) + '</p>' : '') +
        '<figure class="rz-dl__shot"></figure></div>' +
      '<div class="rz-dl__tech"><h2 class="rz-dl__h">The details</h2>' +
        rows.map(function (r, i) { return row((i < 9 ? '0' : '') + (i + 1), r[0], r[1], r[2]); }).join('') + '</div></div>';
    var shot = $('.rz-gal__img');   // the Design block always shows the first product photo (user, 2026-10-16)
    if (shot) {
      var im = shot.cloneNode(); im.removeAttribute('id'); im.loading = 'lazy'; im.alt = ''; im.className = ''; im.removeAttribute('style');
      im.sizes = '(min-width: 990px) 34vw, 100vw'; wrap.querySelector('.rz-dl__shot').appendChild(im);
    } else wrap.querySelector('.rz-dl__shot').remove();
    root.appendChild(wrap);
    // size guide: cm by default (EU), inch on request
    function setUnit(u) {
      wrap.querySelectorAll('[data-in]').forEach(function (c) { var v = parseFloat(c.dataset.in); c.textContent = u === 'cm' ? String(Math.round(v * 2.54)) : c.dataset.in; });
      wrap.querySelectorAll('[data-unit-label]').forEach(function (c) { c.innerHTML = '<strong>' + esc(c.dataset.unitLabel.replace(/inches/i, u === 'cm' ? 'cm' : 'inches')) + '</strong>'; });
      wrap.querySelectorAll('[data-u]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.dataset.u === u)); });
    }
    wrap.addEventListener('click', function (e) { var b = e.target.closest('[data-u]'); if (b) setUnit(b.dataset.u); });
    setUnit('cm');
  })();

  /* ---------- 6 same phrase / the product's line / buy the whole line ---------- */
  (function () {
    var all = json('[data-all]'), self = json('[data-self]'), coll = json('[data-coll]');
    if (!info || !all || !self || root.querySelector('.rz-also, .rz-bundle')) return;
    function sp(t) { var q = rzParts(t); return { ph: q[0], kind: q[1] || '' }; }
    var me = sp(self.t).ph.toLowerCase();
    // the other prints of this piece are in the Print choice, not cards
    var printU = {}; $$('[data-rz-prints] a').forEach(function (a) { printU[a.pathname] = 1; });
    var same = all.filter(function (p) { return p.u !== self.u && !printU[p.u] && sp(p.t).ph.toLowerCase() === me; }).slice(0, 4);
    var seen = {}, others = [];
    all.forEach(function (p) {
      var k = sp(p.t).ph.toLowerCase(); if (k === me || p.u === self.u) return;
      var hoodie = /hoodie/i.test(p.t) && !/crop/i.test(p.t);
      if (!(k in seen)) { seen[k] = others.length; others.push(p); } else if (hoodie && !/hoodie/i.test(others[seen[k]].t)) others[seen[k]] = p;
    });
    var seed = 0; for (var i = 0; i < self.u.length; i++) seed = (seed * 31 + self.u.charCodeAt(i)) >>> 0;
    others.sort(function (a, b) { return ((a.u.length * 7 + seed) % 13) - ((b.u.length * 7 + seed) % 13) || (a.u < b.u ? -1 : 1); });
    var more = others.slice(0, Math.max(0, 4 - same.length));
    function cards(list) {
      return '<ul class="rz-also__cards" role="list">' + list.map(function (p) {
        var t = sp(p.t), name = rzWith(t.ph.toLowerCase() === me ? (t.kind || p.t) : t.ph, p.u);
        return '<li><a href="' + esc(p.u) + '"><span class="rz-also__img"><img loading="lazy" alt="" src="' + esc(p.i) + '"></span>' +
          '<span class="rz-also__n">' + esc(name) + '</span><span class="rz-also__p">' + (p.a === false ? '<span class="rz-stock">Sold out</span>' : esc(p.p)) + '</span></a></li>';
      }).join('') + '</ul>';
    }
    var box = document.createElement('div'); box.className = 'rz-also';
    if (!coll) {
      var head = !same.length ? 'More phrases' : (more.length ? 'Same phrase, and more' : 'Same phrase');
      box.innerHTML = '<p class="rz-label">' + head + '</p>' + cards(same.concat(more));
    } else {
      var sameU = {}; same.forEach(function (p) { sameU[p.u] = 1; });
      var rest = coll.items.filter(function (p) { return p.u !== self.u && !sameU[p.u] && !printU[p.u]; });
      var h = same.length ? '<p class="rz-label">Same phrase</p>' + cards(same) : '';
      if (rest.length) {
        h += '<p class="rz-label rz-also__h2">From the ' + esc(coll.t) + ' collection</p>' + cards(rest.slice(0, 4)) +
          (coll.n > 4 + (same.length ? 0 : 1) ? '<a class="rz-also__all" href="' + esc(coll.u) + '">See all ' + coll.n + ' pieces →</a>' : '');
      }
      if (coll.n >= 2 && coll.n <= coll.max) h += '<div class="rz-bundle" data-bundle></div>';
      box.innerHTML = h;
      var bundle = box.querySelector('[data-bundle]');
      if (bundle) {
        // every available piece, in the size picked here when it exists
        var sizeVal = function () {
          var f = fieldsets.filter(function (x) { return /size|größe/i.test(txt(x.querySelector('legend'))); })[0] || fieldsets[fieldsets.length - 1];
          var c = f && f.querySelector('input:checked'); return c ? c.value : '';
        };
        var pick = function () {
          var size = sizeVal();
          return coll.items.map(function (p) {
            var v = p.v.filter(function (x) { return x.a && x.o.indexOf(size) > -1; })[0] || p.v.filter(function (x) { return x.a; })[0];
            return v ? { id: v.id, c: v.c } : null;
          }).filter(Boolean);
        };
        var money = function (c) { return rz.money ? rz.money(c) : '€' + (c / 100).toFixed(2).replace('.', ','); };
        var draw = function () {
          var items = pick(), total = items.reduce(function (s, x) { return s + x.c; }, 0);
          // the discount only kicks in with every piece of the line in the cart, so it's only promised when all are available
          var off = coll.on && coll.pct > 0 && items.length >= coll.n ? Math.round(total * (100 - coll.pct) / 100) : 0;
          bundle.innerHTML = '<p class="rz-label">The whole collection</p>' +
            '<div class="rz-bundle__row"><span class="rz-bundle__t">All ' + items.length + ' ' + esc(coll.t) + ' pieces</span>' +
            '<span class="rz-bundle__p">' + (off ? '<s>' + money(total) + '</s> ' + money(off) : money(total)) + '</span></div>' +
            (off ? '<p class="rz-bundle__note">−' + coll.pct + ' % on the full collection, applied at checkout</p>' : '<p class="rz-bundle__note">In your size where it exists, otherwise the first one left</p>') +
            '<button type="button" class="rz-bundle__btn"' + (items.length < 2 ? ' disabled' : '') + '>' + (off ? 'Add the whole collection −' + coll.pct + ' % →' : 'Add the whole collection →') + '</button>';
        };
        draw();
        root.addEventListener('rz:variant', draw);
        bundle.addEventListener('click', function (e) {
          var b = e.target.closest('.rz-bundle__btn'); if (!b || b.disabled) return;
          b.disabled = true; b.textContent = 'Adding…';
          fetch((rz.routes ? rz.routes.cartAdd : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: pick().map(function (x) { return { id: x.id, quantity: 1 }; }) }) })
            .then(function (r) { if (!r.ok) throw r; location.href = rz.routes ? rz.routes.cart : '/cart'; })
            .catch(function () { b.disabled = false; b.textContent = 'Something went wrong. Try again'; });
        });
      }
    }
    // the cards: their own panel right under the product, one row across (user, 2026-10-18: "into a row, to better use
    // the space"); outside the product card, so the sticky photo and info column stop before it.
    // Buying the whole line stays in the info column, next to Add to cart.
    var bundleEl = box.querySelector('[data-bundle]');
    if (bundleEl) info.appendChild(bundleEl);
    if (!box.querySelector('.rz-also__cards')) return;
    var top = card && card.parentElement;
    if (!top || !top.parentElement) return info.appendChild(box);
    var row = document.createElement('section');
    row.className = 'rz-card-wrap rz-also-wrap'; row.setAttribute('aria-label', 'More pieces');
    box.classList.add('rz-card'); row.appendChild(box);
    top.after(row);
  })();

  layout();
  addEventListener('resize', layout, sig); addEventListener('load', layout, sig);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

  /* ---------- 7 sticky add to cart: once the real button has scrolled away ---------- */
  (function () {
    var block = $('[data-rz-buy]');
    if (!addBtn || !block || !h1 || document.querySelector('.rz-sticky')) return;
    var bar = document.createElement('div');
    bar.className = 'rz-sticky'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<span class="rz-sticky__img"></span><span class="rz-sticky__txt"><span class="rz-sticky__name"></span><span class="rz-sticky__meta"></span></span>' +
      '<span class="rz-sticky__price"></span><button type="button" class="rz-sticky__btn" tabindex="-1"><span></span></button>';
    bar.querySelector('.rz-sticky__name').textContent = txt(h1.querySelector('.rz-name')) || txt(h1);
    document.body.appendChild(bar);
    // the picture is the selected variant's photo (user, 2026-10-18: "wrong thumbnail colour"). Photos are told apart
    // by their file (src), never currentSrc: that stays empty until a photo has loaded, so two colours not loaded yet
    // looked the same and the bar kept the first one's picture.
    function photo() {
      var fi = gallery.imageFor ? gallery.imageFor(current) : gallery.firstImage && gallery.firstImage();
      var wrap = bar.querySelector('.rz-sticky__img'), box = wrap.querySelector('img');
      if (!fi) return;
      var src = fi.getAttribute('src');
      if (!box) { box = document.createElement('img'); box.alt = ''; box.decoding = 'async'; wrap.appendChild(box); }
      if (box.getAttribute('data-src') === src) return;
      box.sizes = '96px'; box.srcset = fi.getAttribute('srcset') || ''; box.src = src; box.setAttribute('data-src', src);
    }
    photo();
    var meta = bar.querySelector('.rz-sticky__meta'), price = bar.querySelector('.rz-sticky__price'), btn = bar.querySelector('.rz-sticky__btn');
    function sync() {
      var shown = txt(priceEl).replace(/\s+[A-Z]{3}$/, '');   // the bar is small: €60,00 without the currency code
      price.textContent = shown;
      meta.innerHTML = '';
      [[kindEl ? txt(kindEl) : '', 'rz-sticky__k'], [current && current.t !== 'Default Title' ? current.t.replace(/ \/ /g, ' · ') : '', ''], [shown, 'rz-sticky__mp']].forEach(function (x) {
        if (!x[0]) return; var s = document.createElement('span'); if (x[1]) s.className = x[1]; s.textContent = x[0]; meta.appendChild(s);
      });
      btn.querySelector('span').textContent = txt(addLabel) || 'Add to cart';
      btn.disabled = addBtn.disabled; btn.classList.toggle('is-soldout', addBtn.classList.contains('is-soldout'));
    }
    sync();
    root.addEventListener('rz:variant', sync);
    // the picture follows the variant picked (after the gallery has swapped in that colour's photos)
    root.addEventListener('rz:variant', function () { setTimeout(photo, 0); });
    new MutationObserver(sync).observe(addBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    btn.addEventListener('click', function () { if (!btn.disabled) addBtn.click(); });
    var foot = document.querySelector('.shopify-section-group-footer-group'), head = document.querySelector('.rz-hd-sec');
    function check() {
      var past = block.getBoundingClientRect().bottom < 0;
      var atFoot = !!foot && foot.getBoundingClientRect().top < innerHeight * .9;
      var hb = head && !head.classList.contains('is-hidden') ? head.getBoundingClientRect().bottom : 0;   // desktop: hangs just under the header when it is back
      bar.style.setProperty('--rz-sticky-top', Math.max(12, Math.round(hb) + 12) + 'px');
      var on = past && !atFoot;
      bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', String(!on)); btn.tabIndex = on ? 0 : -1;
    }
    addEventListener('scroll', check, { passive: true, signal: sig.signal }); addEventListener('resize', check, sig); addEventListener('load', check, sig); check();
  })();

  /* ---------- 8 "You might also wear" (loads later): the piece line gets the identity label ---------- */
  function relLabels() {
    document.querySelectorAll('.rz-rel__item > a').forEach(function (a) {
      if (a.dataset.rzl) return; a.dataset.rzl = 1;
      var m = a.querySelector('.rz-rel__m'); if (m && window.rzWith) m.textContent = rzWith(m.textContent.trim(), a.getAttribute('href'));
    });
  }
  var rel = document.querySelector('.rz-rel');
  if (rel && !rel.dataset.rzObs) { rel.dataset.rzObs = 1; relLabels(); new MutationObserver(relLabels).observe(rel, { childList: true, subtree: true }); }
}
rzProduct();

/* ---------- 9 the Print choice swaps the other print in, no page reload (user, 2026-10-18: "should be smoother") ----------
   Front / back / both are separate products on the same template: their product section comes from the Section
   Rendering API (?section_id=), replaces this one once its first photo is ready, the address follows, and
   rzProduct() runs on it. Hovering a Print box fetches it ahead. Back / forward swap the same way. */
(function () {
  if (!window.fetch || !window.DOMParser || !history.pushState) return;
  var cache = {};
  function wrapEl() { var r = document.querySelector('[data-rz-product]'); return r && r.closest('.shopify-section'); }
  function load(href) {
    var w = wrapEl(); if (!w) return Promise.reject();
    var u = new URL(href, location.href); u.searchParams.set('section_id', w.id.replace(/^shopify-section-/, ''));
    var key = u.toString();
    if (!cache[key]) cache[key] = fetch(key).then(function (r) { if (!r.ok) throw r; return r.text(); });
    cache[key].catch(function () { delete cache[key]; });
    return cache[key];
  }
  function ready(doc) {   // the new first photo decoded, or 800 ms, whichever comes first
    var img = doc.querySelector('.rz-gal__slide.is-on .rz-gal__img') || doc.querySelector('.rz-gal__slide:not([hidden]) .rz-gal__img');
    if (!img) return Promise.resolve();
    var pre = new Image(); pre.sizes = img.getAttribute('sizes') || ''; pre.srcset = img.getAttribute('srcset') || ''; pre.src = img.getAttribute('src') || '';
    return Promise.race([pre.decode ? pre.decode().catch(function () {}) : Promise.resolve(), new Promise(function (r) { setTimeout(r, 800); })]);
  }
  var busy = false;
  function swap(href, push) {
    var w = wrapEl(); if (!w || busy) return;
    busy = true; w.classList.add('is-swapping');
    load(href).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.getElementById(w.id) || doc.querySelector('.shopify-section');
      if (!fresh || !fresh.querySelector('[data-rz-product]')) throw new Error('no product section');
      return ready(fresh).then(function () {
        var y = scrollY, bar = document.querySelector('.rz-sticky');
        if (bar) bar.remove();   // the new product builds its own
        w.innerHTML = fresh.innerHTML;
        if (push) history.pushState({ rzPrint: 1 }, '', href);
        rzProduct();
        scrollTo(0, y);
        var g = w.querySelector('.rz-gal'); if (g) g.classList.add('is-new');
        var now = w.querySelector('[data-rz-prints] a[aria-current]'); if (now && push) now.focus({ preventScroll: true });   // keyboard users stay on the Print choice
        document.dispatchEvent(new CustomEvent('rz:product-swap'));
      });
    }).catch(function () { location.href = href; }).then(function () { busy = false; w.classList.remove('is-swapping'); });
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-rz-prints] a');
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    if (!a.hasAttribute('aria-current')) swap(a.href, true);
  });
  document.addEventListener('pointerover', function (e) {
    var a = e.target.closest && e.target.closest('[data-rz-prints] a[data-v]'); if (a) load(a.href).catch(function () {});
  }, { passive: true });
  document.addEventListener('focusin', function (e) {
    var a = e.target.closest && e.target.closest('[data-rz-prints] a[data-v]'); if (a) load(a.href).catch(function () {});
  });
  // phones have no hover: once the page is quiet (and again after a colour or size pick) the other prints and their
  // first photo load in the background (~9 KB each plus the photo), so a tap swaps at once. Not with data saver on.
  var saver = navigator.connection && navigator.connection.saveData, warmT;
  var idle = window.requestIdleCallback || function (f) { return setTimeout(f, 200); };
  function warm() {
    var w = wrapEl(); if (!w) return;
    document.querySelectorAll('[data-rz-prints] a[data-v]').forEach(function (a) {
      load(a.href).then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById(w.id);
        if (fresh) ready(fresh);
      }).catch(function () {});
    });
  }
  function warmSoon(ms) { if (saver) return; clearTimeout(warmT); warmT = setTimeout(function () { idle(warm); }, ms); }
  if (document.querySelector('[data-rz-prints]')) warmSoon(1500);
  document.addEventListener('rz:variant', function () { warmSoon(700); }, true);   // capture: rz:variant doesn't bubble
  document.addEventListener('rz:product-swap', function () { warmSoon(800); });
  addEventListener('popstate', function () {
    var r = document.querySelector('[data-rz-product]');
    if (r && r.querySelector('[data-rz-prints]') && r.dataset.url !== location.pathname) swap(location.href, false);
  });
})();
